import { DispatchLeg } from '@api/Trinium/Endpoints/Dispatch/types';
import RenderHeader from '@components/DataGrid/RenderHeader';
import RailBillingCell from '../Cells/RailBilling';
import { GridColDefExtended } from '@mui/x-data-grid-pro';

const headerDisplayName = 'RB';

const railBillingDefinition: GridColDefExtended<DispatchLeg> = {
	field: 'railBilling',
	minWidth: 60,
	width: 60,
	headerName: 'RailBilling',
	headerDisplayName,
	display: 'flex',
	align: 'center',
	renderHeader: () => <RenderHeader primaryText={headerDisplayName} />,
	renderCell: RailBillingCell,
	sortable: false,
	disableReorder: true,
	valueGetter: (_, row: DispatchLeg) => row.isRailBilled
};

export default railBillingDefinition;
